<template>
  <v-card
      class="px-3 py-4 oder-box-products"
      outlined
      tile
  >
    <div class="align-start d-flex justify-space-between">
      <div
          style="color: #ac0606; font-weight: 600; font-size: 14px"
          class="d-flex pl-3 mb-6"
      >
        <span style="width: 150px">Sản phẩm gia sư</span>
        <div class="d-flex pl-6">
          <v-checkbox
              label="Bán mới"
              hide-details
              class="table-layout-checkbox ma-0 pa-0"
              v-model="product.isNew"
              :disabled="isDetailOrder"
              @change="clickNew(product)"
          />
          <v-checkbox
              label="Gia hạn"
              hide-details
              class="table-layout-checkbox ma-0 pa-0 ml-6"
              v-model="product.isExtend"
              :disabled="isDetailOrder"
              @change="clickExtend(product)"
          />
        </div>
      </div>
      <div v-if="!isDetailOrder" @click="deleteProduct(product, indexProd)" class="cursor-pointer mt-1">
        <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M4.4987 0.927734V1.76107H0.332031V3.42773H1.16536V14.2611C1.16536 14.7031 1.34096 15.127 1.65352 15.4396C1.96608 15.7521 2.39 15.9277 2.83203 15.9277H11.1654C11.6074 15.9277 12.0313 15.7521 12.3439 15.4396C12.6564 15.127 12.832 14.7031 12.832 14.2611V3.42773H13.6654V1.76107H9.4987V0.927734H4.4987ZM2.83203 3.42773H11.1654V14.2611H2.83203V3.42773ZM4.4987 5.0944V12.5944H6.16536V5.0944H4.4987ZM7.83203 5.0944V12.5944H9.4987V5.0944H7.83203Z"
              fill="#AC0606"
          />
        </svg>
      </div>
    </div>
    <v-row>
      <v-col cols="12" class="py-0 pt-2">
        <v-simple-table class="table-layout table-order-custom-tutor">
          <thead>
          <tr>
            <th class="col-program text-left" style="font-size: 12px !important;width: 30% !important;">
              CHƯƠNG TRÌNH
            </th>
            <th class="col-program text-left" style="font-size: 12px !important;width: 30% !important;">
              LỘ TRÌNH
            </th>
            <th class="col-program text-left" style="font-size: 12px !important;width: 20% !important;">
              LOẠI LỚP
            </th>
            <th class="col-teacher text-left" style="font-size: 12px !important;width: 20% !important;">
              LOẠI GV
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <validation-provider
                  v-slot="{ errors }"
                  :name="`Chương trình ${indexProd + 1}`"
                  :rules="{ required: true }"
              >
                <v-autocomplete
                    :items="curriculums"
                    :error-messages="errors"
                    item-value="id"
                    item-text="title"
                    :aLight="'right'"
                    placeholder="Chọn"
                    label=""
                    auto
                    :disabled="isDetailOrder"
                    class="product-select-curriculum"
                    v-model="product.curriculumId"
                    @change="onChangeCurriculum(product)"
                    :menu-props="{
                        top: true,
                        offsetY: true,
                        maxHeight: '250',
                      }"
                >
                </v-autocomplete>
              </validation-provider>
            </td>
            <td>
              <validation-provider
                  v-slot="{ errors }"
                  :name="`Lộ trình ${indexProd + 1}`"
                  :rules="{ required: true }"
              >
                <v-autocomplete
                    :items="product.listlevels"
                    :error-messages="errors"
                    item-value="id"
                    item-text="title"
                    :aLight="'right'"
                    placeholder="Chọn"
                    label=""
                    auto
                    :disabled="isDetailOrder"
                    class="product-select-curriculum"
                    v-model="product.learningPathId"
                    @change="onChangeTeacherType(product)"
                    :menu-props="{
                        top: true,
                        offsetY: true,
                        maxHeight: '250',
                      }"
                >
                </v-autocomplete>
              </validation-provider>
            </td>
            <td>
              <validation-provider
                  v-slot="{ errors }"
                  :name="`Loại lớp ${indexProd + 1}`"
                  :rules="{ required: true }"
              >
                <v-autocomplete
                    :error-messages="errors"
                    :items="classes"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn "
                    label=""
                    :disabled="isDetailOrder"
                    auto
                    v-model="product.classTypeId"
                    @change="onChangeTeacherType(product)"
                    :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '250',
                          }"
                ></v-autocomplete>
              </validation-provider>
            </td>
            <td>
              <validation-provider
                  v-slot="{ errors }"
                  :name="`Giáo viên ${indexProd + 1}`"
                  :rules="{ required: true }"
              >
                <v-autocomplete
                    :error-messages="errors"
                    :items="teacherTypes"
                    item-value="id"
                    item-text="name"
                    :disabled="isDetailOrder"
                    :aLight="'right'"
                    placeholder="Chọn "
                    label=""
                    auto
                    v-model="product.teacherType"
                    @change="onChangeTeacherType(product)"
                    :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '250',
                          }"
                ></v-autocomplete>
              </validation-provider>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-simple-table
            class="table-layout table-order-custom-tutor"
            :style="{  background: product && product.isTransfered ? 'rgba(204, 204, 204, 1)' : '#fffbf8'}">
          <thead>
          <tr>
            <th
                class="col-product text-left pb-0"
                style="font-size: 12px !important;width: 55% !important;"
            >
              SẢN PHẨM
            </th>
            <th
                class="col-price text-left pb-0"
                style="font-size: 12px !important;width: 20% !important;"
            >
              ĐƠN GIÁ
            </th>
            <th
                class="col-count text-left pb-0"
                style="font-size: 12px !important; width: 25% !important;"
            >
              {{ paymentMethod === 1  ? 'SỐ LƯỢNG TỐI ĐA' : 'SỐ LƯỢNG' }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="text-left">
              <validation-provider
                  v-slot="{ errors }"
                  :name="`Sản phẩm ${indexProd + 1}`"
                  :rules="{ required: true }"
              >
                <v-autocomplete
                    :items="product.products"
                    :error-messages="errors"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    :disabled="isDetailOrder"
                    placeholder="Chọn"
                    label=""
                    style="padding: 0 !important; font-size: 14px !important;"
                    auto
                    :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '310',
                          }"
                    @change="onSelectProduct(product)"
                    v-model="product.productId"
                >
                  <template slot="selection" slot-scope="data">
                            <span v-if="innerWidth > 1440">{{
                                data.item.name.length > 120
                                    ? `${data.item.name.slice(0, 120)}...`
                                    : data.item.name
                              }}</span>
                    <span v-else>{{
                        data.item.name.length > 40
                            ? `${data.item.name.slice(0, 40)}...`
                            : data.item.name
                      }}</span>
                  </template>
                  <template slot="item" slot-scope="data">
                    <div>
                              <span
                                  style="font-weight: bold; font-size: 14px"
                              >{{ data.item.name }}</span
                              >

                      <div class="text-muted d-flex">
                        <v-icon color="#564F4C">
                          mdi-circle-small
                        </v-icon>
                        <span
                            style="font-style: italic; font-size: 10px"
                        >{{
                            curriculumObj[data.item.curriculumId]
                          }}</span
                        >
                      </div>

                      <div class="text-muted d-flex">
                        <v-icon color="#564F4C">
                          mdi-circle-small
                        </v-icon>
                        <span
                            style="font-style: italic; font-size: 10px"
                        >{{ classTypeObj[data.item.classTypeId] }} -
                                  {{ teacherTypeObj[data.item.teacherTypeId] }}
                                  - {{ data.item.numOfLesson }} buổi</span
                        >
                      </div>
                    </div>
                  </template>
                </v-autocomplete>
              </validation-provider>
            </td>
            <td class="text-left" style="padding-top: 0px !important;">
              <div style="border-bottom: 1px solid #d2d2d2;padding-bottom: 4px"
                   v-if="product.priceType && product.priceType === 'unchanged'"
              >
                {{
                  product.price || product.price === 0
                      ? formatCurrency(product.price)
                      : '-'
                }}
              </div>
              <validation-provider
                  v-else
                  v-slot="{ errors }"
                  :name="`Đơn giá ${indexProd + 1}`"
                  :rules="{
                    required: true,
                    max_value: product.maxPrice,
                    min_value: product.minPrice,
                  }"
              >
                <v-text-field
                    label=""
                    :error-messages="errors"
                    :placeholder="
                      product.productId
                        ? `${formatCurrency(
                            product.minPrice
                          )} - ${formatCurrency(product.maxPrice)}`
                        : 'Nhập số tiền'
                   "
                    dense
                    style="padding-top: 0 !important;"
                    type="number"
                    v-model="product.price"
                ></v-text-field>
              </validation-provider>
            </td>
            <td class="text-left">
              <validation-provider
                  v-slot="{ errors }"
                  :name="`Số lượng ${indexProd + 1}`"
                  :rules="{ required: true, max_value: 100, min_value: 1 }"
              >
                <v-text-field
                    type="number"
                    :error-messages="errors"
                    dense
                    :min="1"
                    style="padding-top: 0 !important;"
                    :readonly="paymentMethod === 1"
                    :max="10000"
                    :suffix="paymentMethod === 1 ? '(buổi)' : ''"
                    placeholder="-"
                    :class='paymentMethod === 1 ? "input-number-lesson text-field-number" : "text-field-number"'
                    v-model="product.quantity"
                    @input="product.quantity= product.quantity.replace(/[^0-9\.]/g,'');"
                />
              </validation-provider>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>

import TransferFeeDuo from "../../../repository/TransferFeeDuo";
import {formatCurrency} from "../../../helper/FuncProduct";
import _ from "lodash";

export default {
  props: {
    paymentMethod: {
      type: Number,
      default: 0,
    },
    totalRemainAmount: {
      type: Number,
      default: 0,
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    indexProd: {
      type: Number,
      default: 0,
    },
    isDetailOrder: {
      type: Boolean,
      default: false,
    },
    curriculums: {
      type: Array,
      default: () => [],
    },
    teacherTypes: {
      type: Array,
      default: () => [],
    },
    classes: {
      type: Array,
      default: () => [],
    },
    curriculumObj: {
      type: Object,
      default: () => ({}),
    },
    teacherTypeObj: {
      type: Object,
      default: () => ({}),
    },
    classTypeObj: {
      type: Object,
      default: () => ({}),
    },
    innerWidth: {
      type: Number,
      default: 0,
    },
    skuTutors: {
      type: Array,
      default: () => [],
    },
    urlOMS: {
      type: String,
      default: '',
    },
  },
  watch: {
    totalRemainAmount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.debouncedFetchProducts();
      }
    },
    isDetailOrder: {
      handler(newValue) {
        // console.log(111, newValue)
        if (newValue) {
          this.searchSku('tutor', this.product)
          this.onSelectProduct(this.product)
          // this.onChangeCurriculum(this.product)
          // this.onSelectProduct(this.product)
          // this.onChangeTeacherType(this.product)
          // this.onChangeCurriculum(this.product)
        }
      },
      immediate: true,
    },
  },
  methods: {
    debouncedFetchProducts: _.debounce(async function () {
      await this.searchSku('tutor', this.product)
      this.onSelectProduct(this.product)
    }, 1500),
    formatCurrency,
    onSelectProduct(product){
      const productSelected = product.products.find((item) => item.id === product.productId);
      product.productID = productSelected.productId;
      product.curriculumId = productSelected.curriculumId;
      product.teacherType = productSelected.teacherTypeId;
      product.productName = productSelected.name;
      product.subjectId = productSelected.subjectId;
      product.package = `${productSelected.classTypeId}-${productSelected.numOfLesson}`;
      product.classTypeId = productSelected.classTypeId;
      product.productCode = productSelected.code;
      product.campaigns = [];
      product.endDate = productSelected.endDate;
      if(!this.isDetailOrder) {
        product.pricePerLesson = productSelected.pricePerLesson;
        product.quantity = this.paymentMethod === 1 ? (productSelected.maxNumberOfLessonFeeTransfer || 0) : 1;
      }
      if (productSelected.pricePolicies.length) {
        product.priceType = productSelected.pricePolicies[0].priceType;
        product.price = null;
        if (productSelected.pricePolicies[0].priceType == 'unchanged') {
          product.price = productSelected.pricePolicies[0].minPrice;
        }else if(productSelected.pricePolicies[0].priceType == 'custom') {
          product.price = productSelected.pricePolicies[0].maxPrice;
        }
        product.maxPrice = productSelected.pricePolicies[0].maxPrice;
        product.minPrice = productSelected.pricePolicies[0].minPrice;
      }else {
        product.price = productSelected.orgPrice;
      }
      if(this.isDetailOrder) {
        if (product) {
          const dataFind = this.curriculums.find((item) => item.id === product.curriculumId);
          product.listlevels = dataFind ? dataFind.program_groups : [];
        } else {
          product.listlevels = [];
          product.learningPathId = null;
        }
      }
    },
    async searchSku(product_type = 'tutor', product) {
      // const pac = product.packageOptions.find(item => item.uniqueId === product.package);
      const params = {
        product_type,
        include_price_policy: 1,
        class_type_ids: product.classTypeId,
        teacher_type_ids: product.teacherType,
        curriculum_id: product.curriculumId,
        transaction_status: 'selling',
        status: 'active',
        learning_path_ids: product.learningPathId
      };
      if(this.paymentMethod === 1) {
        params.num_of_lesson = 1;
      }
      if(this.totalRemainAmount) {
        params.lte_price = this.totalRemainAmount;
      }
      const res = await TransferFeeDuo.advanceSearchForComboV2(this.urlOMS,params);
      product.products = res.data;
    },
    getSearchProduct(item) {
      if (item.curriculumId && item.learningPathId && item.classTypeId && item.teacherType) {
        this.searchSku('tutor', item);
      }
    },
    onChangeTeacherType(product) {
      product.productId = null;
      product.productName = null;
      product.package = null;
      product.price = null;
      product.products = [];
      product.campaigns = [];
      this.getSearchProduct(product);
    },
    async onChangeCurriculum(product) {

      product.productId = null;
      product.learningPathId = null;
      product.productName = null;
      product.package = null;
      product.price = null;
      product.products = [];
      product.campaigns = [];
      if (product) {
        const dataFind = this.curriculums.find((item) => item.id === product.curriculumId);
        product.listlevels = dataFind ? dataFind.program_groups : [];
      } else {
        product.listlevels = [];
        product.learningPathId = null;
      }
      this.getSearchProduct(product);
    },
    clickNew(product) {
      product.isExtend = false
      product.campaigns = [];
    },
    clickExtend(product) {
      product.isNew = false;
      product.campaigns = [];
    },
    // function $emit for parent component
    deleteProduct(product, index) {
      this.$emit("deleteProduct", { product, index });
    },
  },
};
</script>

<style lang="scss">
.text-field-number {
  .v-text-field__slot .v-text-field__suffix {
    font-size: 12px !important;
    font-style: italic !important;
    color: rgba(0, 0, 0, 0.87) !important;
  }
}
.input-number-lesson {
  input {
    font-weight: 500;
    color: #129700 !important;
  }
}
</style>
<style lang="scss" scoped>
::v-deep.v-input__control {
  min-height: 10px;
}

::v-deep .v-data-table th {
  font-size: 16px !important;
}
::v-deep .v-data-table td,
::v-deep .v-data-table table thead tr th {
  font-size: 14px !important;
  padding: 10px 12px !important;
  padding-bottom: 0 !important;
}

.price {
  background: #d9d9d9;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 5px;
  font-weight: 400;
  height: 38px;
  line-height: 28px;
  border-radius: 4px;
}
::v-deep
.v-text-field--outlined.v-input--dense.v-text-field--outlined
> .v-input__control
> .v-input__slot {
  min-height: 38px !important;
}

.table-order-custom {
  .col-program {
    width: 12%;
  }
  .col-package {
    width: 12%;
  }
  .col-product {
    width: 12%;
  }
  .col-price {
    width: 12%;
  }
  .col-discount {
    width: 12%;
  }
  .col-total {
    width: 12%;
  }
  .col-child {
    width: 12%;
  }
}

.table-order-custom-tutor {
  th {
    min-width: 100px !important;
    padding-bottom: 0 !important;
    height: 24px !important;
  }
  .col-program {
    width: 240px;
  }
  .col-teacher {
    width: 100px;
  }
  .col-package {
    width: 120px;
  }
  .col-product {
    width: 210px;
  }
  .col-count {
    min-width: 60px !important;
    width: 85px !important;
  }
  .col-price {
    width: 150px;
  }
  .col-discount {
    width: 100px;
  }
  .col-total {
    width: 100px;
  }
  .col-child {
    min-width: 120px !important;
    width: 120px !important;
  }
  .text-muted {
    color: #564f4c;
    font-size: 10px;
  }
}
.table-layout {
  th {
    border-bottom: none !important;
  }
}

.select-customer ::placeholder {
  color: rgb(172, 6, 6) !important;
  font-style: italic;
  font-size: 13px;
}

.cursor-pointer {
  cursor: pointer;
}
.v-text-field {
  padding-top: 0 !important;
}
</style>
